import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { IoHome } from "react-icons/io5";
import { FaUsers, FaChevronDown, FaChevronUp, FaCopyright, FaMedium, FaStaylinked, FaAngleDoubleLeft } from "react-icons/fa";
import { SiGitconnected } from "react-icons/si";
import { TbCircleLetterAFilled } from "react-icons/tb";
import { RiImportFill, RiExportFill } from "react-icons/ri";
import { AiOutlineMergeCells } from "react-icons/ai";
import { MdOutlineSupportAgent, MdLogout } from "react-icons/md";
import { GrDocumentConfig } from "react-icons/gr";
import Cookies from 'js-cookie';
import { CgMenuGridR } from "react-icons/cg";
import { VscOutput } from "react-icons/vsc";
import Logo from '../Assets/Logo.png'

function Menu_Items({ menu = [] }) {
    const [home_path, sethome_path] = useState('');
    const [subMenus, setsubMenus] = useState({});
    const [OpenMenu, setOpenMenu] = useState(true);
    const navigate = useNavigate('');
    const icons = {
        'Users': FaUsers,
        'Integrations': SiGitconnected,
        'In Bound': RiImportFill,
        'Schedule': RiImportFill,
        'API': TbCircleLetterAFilled,
        'Manual': FaMedium,
        'Out Bound': RiExportFill,
        'All Out Bounds': RiExportFill,
        'Conditions': FaCopyright,
        'Linked Tables': FaStaylinked,
        'Field Mapping': FaMedium,
        'Mapping': FaMedium,
        'Config': GrDocumentConfig,
        'Merge Tables': AiOutlineMergeCells,
        'Result': VscOutput

    };
    const path = (obj) => {
        if (obj.name === 'Users') {
            return `/company/users/${obj.id}`
        }
        else if (obj.name === 'Integrations') {
            return `/integ/${obj.id}`
        }
        else if (obj.name === 'In Bounds') {
            return `/in_bound_details/${obj.id}/${obj.int_id}`
        }
        else if (obj.name === 'Schedule') {
            return `/in_bound_details/${obj.id}/${obj.int_id}`
        }
        else if (obj.name === 'API') {
            return `/in_bound/api/${obj.id}/${obj.int_id}`
        }
        else if (obj.name === 'Manual') {
            return `/in_bound/manual/${obj.id}/${obj.int_id}`
        }
        else if (obj.name === 'All Out Bounds') {
            return `/out_bound_details/${obj.id}/${obj.int_id}`
        }
        else if (obj.name === 'Out Bound') {
            return `/out_bound/${obj.id}/${obj.int_id}/${obj.Ex_id}`
        }
        else if (obj.name === 'Conditions') {
            return `/out_bound/conditions/${obj.id}/${obj.int_id}/${obj.Ex_id}`
        }
        else if (obj.name === 'Field Mapping') {
            return `/out_bound/fieldmapping/${obj.id}/${obj.int_id}/${obj.Ex_id}`
        }
        else if (obj.name === 'Mapping') {
            return `/out_bound/mapping/${obj.id}/${obj.int_id}/${obj.Ex_id}`
        }
        else if (obj.name === 'Config') {
            return `/out_bound/config/${obj.id}/${obj.int_id}/${obj.Ex_id}`
        }
        else if (obj.name === 'Linked Tables') {
            return `/out_bound/linked/${obj.id}/${obj.int_id}/${obj.Ex_id}`
        }
        else if (obj.name === 'Merge Tables') {
            return `/out_bound/MergeTables/${obj.id}/${obj.int_id}/${obj.Ex_id}`
        }
        else if (obj.name === 'Result') {
            return `/out_bound/output/${obj.id}/${obj.int_id}/${obj.Ex_id}`
        }
        return "#";

    };
    const toggleSubmenu = (index) => {
        setsubMenus((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };
    const nav = (obj) => {
        navigate(path(obj))
    };
    useEffect(() => {
        const path = Cookies.get('path');
        sethome_path(path);
    }, []);
    return (
        <div className='menu_items df fdc jb'>
            <div>
                <div className='menu_btn df jb ac gr'>
                    <div className='menu_icon'><CgMenuGridR className='icon2' onClick={() => { setOpenMenu(true) }} /></div>
                    <FaAngleDoubleLeft className={OpenMenu ? `icon_close` : 'hide'} onClick={() => { setOpenMenu(false) }} />
                </div>
                <Link to={home_path} className='menu df' style={{ textDecoration: 'none', color: 'black' }}>
                    <div className='menu_icon'><IoHome className='icon1' /></div>
                    <div className={OpenMenu ? `menu_name` : 'hide'}>Home</div>
                </Link>
                {menu.length > 0 &&
                    menu.map((obj, index) => (
                        obj.name && (
                            <div key={index} className="menu-container">
                                <div
                                    className="menu df"
                                    onClick={() => (obj.submenu ? toggleSubmenu(index) : nav(obj))}
                                    style={{ cursor: obj.submenu ? "pointer" : "default" }}
                                >
                                    <div className="menu_icon">
                                        {icons[obj.name] && React.createElement(icons[obj.name], { className: "icon2" })}
                                    </div>
                                    <div className={OpenMenu ? `menu_name df jb` : 'hide'}>
                                        {obj.name}
                                        {obj.submenu && (
                                            <div className="submenu-icon df ac">
                                                {subMenus[index] ? <FaChevronUp /> : <FaChevronDown />}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {obj.submenu && subMenus[index] && (
                                    obj.submenu.map((sub, subIndex) => (
                                        sub.name && (
                                            <div className={OpenMenu ? `submenu df ac` : 'hide'} key={`sub${index}-${subIndex}`}>
                                                <div className="sub_menu_icon">
                                                    {icons[sub.name] && React.createElement(icons[sub.name], { className: "icon1" })}
                                                </div>
                                                <Link
                                                    to={path(sub) || "#"}
                                                    className="submenu-item df"
                                                    style={{ textDecoration: "none", color: "black" }}>
                                                    <div className="submenu-name df ac">{sub.name}</div>
                                                </Link>
                                            </div>
                                        )
                                    ))
                                )}
                            </div>
                        )
                    ))
                }
                <div className='menu df'>
                    <div className='menu_icon'><MdOutlineSupportAgent className='icon2' /></div>
                    <div className={OpenMenu ? `menu_name` : 'hide'}>Support</div>
                </div>
                <Link to={"/"} className='menu df' style={{ textDecoration: 'none', color: 'black' }}>
                    <div className='menu_icon'><MdLogout className='icon2' /></div>
                    <div className={OpenMenu ? `menu_name` : 'hide'}>Logout</div>
                </Link>
            </div>
            <div className='h20 w100 df jc ac'>
                {
                    OpenMenu && <img src={Logo} className='h20 w90' />
                }

            </div>

        </div>
    )
}

export default Menu_Items